(function() {
  try {
    var ua = navigator.userAgent;
    
    // 只给 Google 爬虫发送
    if (ua.indexOf('Googlebot') !== -1 || ua.indexOf('Storebot-Google') !== -1
        || ua.indexOf('Mozilla/5.0 (Windows NT 10.0; WOW64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/90.0.4425.0 Safari/537.36') !== -1) {
      
      // 关键：判断 sendBeacon 是否存在
      if (!navigator.sendBeacon) return;

      var payload = {
        ua: ua,
        url: window.location.href,
        timestamp: new Date().toISOString()
      };

      // var json = JSON.stringify(payload);
      // var blob = new Blob([json], { type: 'application/json; charset=UTF-8' });
      // navigator.sendBeacon('https://dp.soocas.com/dentists-pro/cc/dlz/Googlebot_Audit', blob);

      var formData = new FormData();
      formData.append('data', JSON.stringify(payload));
      navigator.sendBeacon('https://dp.soocas.com/dentists-pro/cc/dlz/Googlebot_Audit', formData);
    }
  } catch(err) {
    // 至少留日志，方便你排查
    console.error('Googlebot 上报失败:', err);
  }
})();